import React, { Component } from 'react'
import { Form, Text } from 'react-form'
import { Notice } from 'components/ui/reusable'
import strings from 'translations/ro.json'
const contact = strings.sections.contact

const encode = (data) => {
	 return Object.keys(data)
			 .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
			 .join('&');
}

class TheForm extends Component {
	render() {
		return (
			<Form
				onSubmit={(values, state, props, instance) => {
					console.log('Success!', values)
					fetch('/', {
						method: 'POST',
						headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
						body: encode({ 'form-name': 'contact', ...values })
					})
						.then(() => instance.resetForm())
						.catch(error => alert(error));
				}}
				validate={values => {
					const { name, phone, company, message } = values
					return {
						name: !name ? contact.errors.name : undefined,
						phone: !phone ? contact.errors.phone : undefined,
						company: !company ? contact.errors.company : undefined,
						message: !message ? contact.errors.message : undefined
					}
				}}
			>
				{({submitForm}) => {
					return (
						/*read more about it: https://www.netlify.com/docs/form-handling/ */
						<form className='form' onSubmit={submitForm}>
							<input type='hidden' name='form-name' value='contact' />
							<Text
								className='form-item'
								field='name'
								placeholder={contact.fields.name}
								errorProps={{
									className:'form-item-error'
								}}/>
							<Text
								className='form-item'
								field='phone'
								placeholder={contact.fields.phone}
								errorProps={{
									className:'form-item-error'
								}}/>
							<Text
								className='form-item'
								field='company'
								placeholder={contact.fields.company}
								errorProps={{
									className:'form-item-error'
								}}/>
							<Text
								className='form-item'
								field='message'
								placeholder={contact.fields.message}
								errorProps={{
									className:'form-item-error'
								}}/>
							<button type='submit'>{contact.fields.submit}</button>
						</form>
					)
				}}
			</Form>
		)
	}
}

class Contact extends Component {
	render() {
		return (
			<section className='contact row' id='contact'>
				<Notice
					className='col-lg-12'
					title={contact.header.title}
					subtitle={contact.header.subtitle} />

				<div className='left-container content-container col-md-6 col-lg-6'>
					<TheForm />
				</div>

				<div className='right-container content-container col-md-6 col-lg-6'>
					<iframe
						title='Viorex Comp'
						width='100%'
						height='100%'
						frameBorder='0'
						style={{border: 0}}
						src="https://www.google.com/maps/embed/v1/search?key=AIzaSyBhT8v-48x-Mu1QPHtq1ebF8BIax0DbQp0
									&q=Viorex+Comp+S.R.L.
									&zoom=18"
						allowFullScreen>
					</iframe>
				</div>
			</section>
		)
	}
}
export default Contact



// WEBPACK FOOTER //
// ./src/components/ui/sections/Contact.js